import {
  FaUser,
  FaEnvelope,
  FaPhone,
  FaCommentDots,
  FaRobot,
  FaHeadset,
  FaQuestionCircle,
  FaHome,
  FaPaperPlane,
  FaCheckCircle,
  FaExclamationCircle,
  FaFacebookF,
  FaTwitter,
  FaInstagram,
  FaTiktok,
  FaWhatsapp,
  FaStore,
  FaHotel,
  FaUtensils,
  FaGlassCheers,
  FaCalendarAlt,
  FaDumbbell,
  FaCcVisa,
  FaCcMastercard,
  FaCcAmex,
  FaCcPaypal
} from 'react-icons/fa';
import paarbusiness from '../assets/images/paarbusiness.png';
import paardigital from '../assets/images/paardigital.png';
import { webDetails, serviceCategory } from '../api/api';
import { Link } from 'react-router';

import { MdSupportAgent, MdLocationOn, MdEmail, MdPhone } from 'react-icons/md';
import { BiSend, BiCheckDouble } from 'react-icons/bi';
import { HiOutlineChatAlt2 } from 'react-icons/hi';

import React, { useEffect, useState } from 'react';
import { NavLink } from "react-router-dom";
import logo from '../assets/images/logo.png'
import googleimage from '../assets/images/googleimage.png'

function Contact() {

  const [sticky, setSticky] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setSticky(window.scrollY > 50);
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);
  const [webData, setWebData] = useState(null);
  const [servCat, serviCateg] = useState(null);

  useEffect(() => {
    webDetails()
      .then((res) => {
        setWebData(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  useEffect(() => {
    serviceCategory()
      .then((res) => {
        serviCateg(res.data.data);
      })
      .catch((err) => {
        console.log(err);
      });
  }, []);

  // const categories = [
  //   { name: "Shops", icon: <FaStore />, url: "/category/shops" },
  //   { name: "Hotels", icon: <FaHotel />, url: "/category/hotels" },
  //   { name: "Restaurants", icon: <FaUtensils />, url: "/category/restaurants" },
  //   { name: "Bars", icon: <FaGlassCheers />, url: "/category/bars" },
  //   { name: "Events", icon: <FaCalendarAlt />, url: "/category/events" },
  //   { name: "Fitness", icon: <FaDumbbell />, url: "/category/fitness" }
  // ];

  const socialLinks = [
    { icon: <FaFacebookF />, url: webData?.faceBook, color: "#1877f2" },
    { icon: <FaTwitter />, url: webData?.twitter, color: "#1da1f2" },
    { icon: <FaInstagram />, url: webData?.instagram, color: "#e4405f" },
    { icon: <FaTiktok />, url: webData?.youtube, color: "#000000" },
    // { icon: <FaWhatsapp />, url: webData?.print, color: "#25d366" }
    {
      icon: <FaWhatsapp />,
      url: webData?.phone ? `https://wa.me/91${webData.phone}` : null,
      color: "#25d366"
    }
  ];

  const paymentIcons = [
    { icon: <FaCcVisa />, name: "Visa" },
    { icon: <FaCcMastercard />, name: "Mastercard" },
    { icon: <FaCcAmex />, name: "American Express" },
    { icon: <FaCcPaypal />, name: "PayPal" }
  ];

  const year = new Date().getFullYear();

  const [formData, setFormData] = useState({
    name: '',
    lastname: '',
    email: '',
    phone: '',
    message: '',
    verify: ''
  });

  const [errors, setErrors] = useState({});
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submitStatus, setSubmitStatus] = useState(null);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({ ...prev, [name]: value }));
    // Clear error when user starts typing
    if (errors[name]) {
      setErrors(prev => ({ ...prev, [name]: '' }));
    }
  };

  const validateForm = () => {
    const newErrors = {};

    if (!formData.name.trim()) newErrors.name = 'Name is required';
    if (!formData.lastname.trim()) newErrors.lastname = 'Last name is required';
    if (!formData.email.trim()) {
      newErrors.email = 'Email is required';
    } else if (!/\S+@\S+\.\S+/.test(formData.email)) {
      newErrors.email = 'Email is invalid';
    }
    if (!formData.phone.trim()) {
      newErrors.phone = 'Phone number is required';
    } else if (!/^[\d\s\-+()]{10,}$/.test(formData.phone)) {
      newErrors.phone = 'Valid phone number is required';
    }
    if (!formData.message.trim()) newErrors.message = 'Message is required';
    if (!formData.verify.trim()) {
      newErrors.verify = 'Please answer the security question';
    } else if (parseInt(formData.verify) !== 4) {
      newErrors.verify = 'Incorrect answer. 3 + 1 = 4';
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    const newErrors = validateForm();

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    setIsSubmitting(true);

    // Simulate API call
    setTimeout(() => {
      setSubmitStatus('success');
      setIsSubmitting(false);
      setFormData({
        name: '',
        lastname: '',
        email: '',
        phone: '',
        message: '',
        verify: ''
      });

      // Clear success message after 5 seconds
      setTimeout(() => setSubmitStatus(null), 5000);
    }, 1500);
  };

  return (
    <>

      <header className={`simple-header ${sticky ? "simple-header--sticky" : ""}`}>
        <div className="container">
          <div className="simple-header__container">
            {/* Logo */}
            <div className="simple-header__logo">
              <NavLink to={'/'} title="Sparker - Directory and listings template">
                <img
                  src={logo}
                  alt="Logo"
                  className="simple-header__logo-img"
                />
              </NavLink>
            </div>

            {/* Desktop Navigation */}
            <nav className="simple-header__nav w-100">
              <ul className="simple-header__nav-list d-flex justify-content-end w-100 list-unstyled m-0">

                <li className="simple-header__nav-item me-3">
                  <NavLink to="/contact" className="simple-header__nav-link">
                    Contact Us
                  </NavLink>
                </li>

                {/* <li className="simple-header__nav-item me-3">
      <NavLink to="/terms" className="simple-header__nav-link">
        Terms and conditions
      </NavLink>
    </li> */}

                <li className="simple-header__nav-item">
                  <NavLink to="/privacy" className="simple-header__nav-link">
                    Privacy Policy
                  </NavLink>
                </li>

              </ul>
            </nav>

            {/* Google Play Store Button */}
            {/* <div className="simple-header__actions">
                        <a
                            href="https://play.google.com/store/apps"
                            className="simple-header__playstore-btn"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={googleimage} alt="googleimage" />
                        </a>
                    </div> */}
            {/* <div className="d-flex gap-2 headerqr">
              <div className="qrimageall">
                <img src={paarbusiness} alt="paarbusiness" />
              </div>
              <div className="qrimageall">
                <img src={paardigital} alt="paardigital" />
              </div>
            </div> */}

            {/* Mobile Menu Button */}
            <button
              className="simple-header__mobile-btn"
              onClick={() => setMenuOpen(!menuOpen)}
              aria-label="Toggle menu"
            >
              <span className={`simple-header__hamburger ${menuOpen ? "simple-header__hamburger--active" : ""}`}>
                <span className="simple-header__hamburger-line"></span>
                <span className="simple-header__hamburger-line"></span>
                <span className="simple-header__hamburger-line"></span>
              </span>
            </button>

            {/* Mobile Navigation Overlay */}
            <div
              className={`simple-header__mobile-overlay ${menuOpen ? "simple-header__mobile-overlay--active" : ""}`}
              onClick={() => setMenuOpen(false)}
            ></div>

            {/* Mobile Navigation Menu */}
            <nav className={`simple-header__mobile-nav ${menuOpen ? "simple-header__mobile-nav--active" : ""}`}>
              <div className="d-flex justify-content-between p-2">
                <div className="simple-header__mobile-header">
                  <img src={logo} alt="Logo" />
                </div>
                <button
                  className="simple-header__mobile-close"
                  onClick={() => setMenuOpen(false)}
                >
                  ✕
                </button>
              </div>
              <ul className="simple-header__mobile-nav-list">

                <li className="simple-header__mobile-nav-item">
                  <a href="/contact" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Contact Us</a>
                </li>
                {/* <li className="simple-header__mobile-nav-item">
                  <a href="/terms" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Terms and conditions</a>
                </li> */}
                <li className="simple-header__mobile-nav-item">
                  <a href="/privacy" className="simple-header__mobile-nav-link" onClick={() => setMenuOpen(false)}>Privacy Policy</a>
                </li>
                <li className="simple-header__mobile-nav-item">
                  <a
                    href="https://play.google.com/store/apps"
                    className="simple-header__mobile-playstore-btn"
                    target="_blank"
                    rel="noopener noreferrer"
                    onClick={() => setMenuOpen(false)}
                  >
                    <img src={googleimage} alt="googleimage" />
                  </a>
                </li>
              </ul>
            </nav>
          </div>
        </div>
      </header>

      {/* HEADER */}
      <div className="sub_header_in sticky_header">
        <div className="container">
          <h1>Contact us</h1>
        </div>
      </div>

      <div className="container-fluid margin_60_35">
        <div className="row justify-content-center">
          {/* Contact Form */}
          <div className="col-xl-5 col-lg-6 pr-xl-5">
            <div className="main_title_3">
              <span><em /></span>
              <h2 style={{ fontSize: '2rem', fontWeight: 'bold', marginBottom: '1rem' }}>
                Send us a message
              </h2>
              <p style={{ color: '#666' }}>We'll get back to you within 24 hours</p>
            </div>

            {/* Success/Error Message */}
            {submitStatus === 'success' && (
              <div style={{
                background: '#d4edda',
                color: '#155724',
                padding: '1rem',
                borderRadius: '10px',
                marginBottom: '1.5rem',
                display: 'flex',
                alignItems: 'center',
                gap: '0.5rem'
              }}>
                <FaCheckCircle style={{ fontSize: '1.2rem' }} />
                <span>Message sent successfully! We'll contact you soon.</span>
              </div>
            )}

            <form onSubmit={handleSubmit} autoComplete="off">
              <div className="row g-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: '500', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <FaUser style={{ color: '#04013a' }} /> First Name
                    </label>
                    <input
                      className={`form-control ${errors.name ? 'is-invalid' : ''}`}
                      type="text"
                      name="name"
                      value={formData.name}
                      onChange={handleChange}
                      placeholder="Enter your first name"
                      style={{ borderRadius: '10px', padding: '0.75rem' }}
                    />
                    {errors.name && <small className="text-danger">{errors.name}</small>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: '500', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <FaUser style={{ color: '#04013a' }} /> Last Name
                    </label>
                    <input
                      className={`form-control ${errors.lastname ? 'is-invalid' : ''}`}
                      type="text"
                      name="lastname"
                      value={formData.lastname}
                      onChange={handleChange}
                      placeholder="Enter your last name"
                      style={{ borderRadius: '10px', padding: '0.75rem' }}
                    />
                    {errors.lastname && <small className="text-danger">{errors.lastname}</small>}
                  </div>
                </div>
              </div>

              <div className="row g-3 mt-2">
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: '500', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <FaEnvelope style={{ color: '#04013a' }} /> Email
                    </label>
                    <input
                      className={`form-control ${errors.email ? 'is-invalid' : ''}`}
                      type="email"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                      placeholder="your@email.com"
                      style={{ borderRadius: '10px', padding: '0.75rem' }}
                    />
                    {errors.email && <small className="text-danger">{errors.email}</small>}
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: '500', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <FaPhone style={{ color: '#04013a' }} /> Telephone
                    </label>
                    <input
                      className={`form-control ${errors.phone ? 'is-invalid' : ''}`}
                      type="tel"
                      name="phone"
                      value={formData.phone}
                      onChange={handleChange}
                      placeholder="+91 9876543210"
                      style={{ borderRadius: '10px', padding: '0.75rem' }}
                    />
                    {errors.phone && <small className="text-danger">{errors.phone}</small>}
                  </div>
                </div>
              </div>

              <div className="form-group mt-3">
                <label style={{ fontWeight: '500', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                  <FaCommentDots style={{ color: '#04013a' }} /> Message
                </label>
                <textarea
                  className={`form-control ${errors.message ? 'is-invalid' : ''}`}
                  name="message"
                  value={formData.message}
                  onChange={handleChange}
                  placeholder="How can we help you?"
                  style={{ height: 150, borderRadius: '10px', padding: '0.75rem' }}
                />
                {errors.message && <small className="text-danger">{errors.message}</small>}
              </div>

              <div className="row mt-3">
                <div className="col-md-6">
                  <div className="form-group">
                    <label style={{ fontWeight: '500', marginBottom: '0.5rem', display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                      <FaRobot style={{ color: '#04013a' }} /> Are you human? 3 + 1 =
                    </label>
                    <input
                      className={`form-control ${errors.verify ? 'is-invalid' : ''}`}
                      type="text"
                      name="verify"
                      value={formData.verify}
                      onChange={handleChange}
                      placeholder="Enter answer"
                      style={{ borderRadius: '10px', padding: '0.75rem' }}
                    />
                    {errors.verify && <small className="text-danger">{errors.verify}</small>}
                  </div>
                </div>
              </div>

              <p className="add_top_30">
                <button
                  type="submit"
                  disabled={isSubmitting}
                  style={{
                    background: ' linear-gradient(359deg, #04013a, #00000a)',
                    border: 'none',
                    padding: '0.9rem 2rem',
                    borderRadius: '50px',
                    color: 'white',
                    fontWeight: '600',
                    display: 'inline-flex',
                    alignItems: 'center',
                    gap: '0.5rem',
                    transition: 'transform 0.3s',
                    cursor: isSubmitting ? 'not-allowed' : 'pointer',
                    opacity: isSubmitting ? 0.7 : 1
                  }}
                  onMouseEnter={(e) => !isSubmitting && (e.target.style.transform = 'translateY(-2px)')}
                  onMouseLeave={(e) => e.target.style.transform = 'translateY(0)'}
                >
                  {isSubmitting ? (
                    <>Sending... <BiSend /></>
                  ) : (
                    <>Send Message <FaPaperPlane /></>
                  )}
                </button>
              </p>
            </form>
          </div>

          {/* Contact Information */}

        </div>
      </div>

      {/* Map Section */}
      <div className="container-fluid mt-5 px-0">
        <iframe
          src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3305.715856210739!2d-118.245364!3d34.054681!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x80c2c75ddc27da13%3A0xe22fdf6f254608f4!2sLos%20Angeles%2C%20CA%2C%20USA!5e0!3m2!1sen!2s!4v1699999999999!5m2!1sen!2s"
          width="100%"
          height="400"
          style={{ border: 0 }}
          allowFullScreen=""
          loading="lazy"
          title="Sparker Directory Location"
        ></iframe>
      </div>

      <footer className="app-footer">

        <div className="container footer-container">
          <div className="row g-4">

            {/* About */}
            <div className="col-lg-6 col-md-6 col-sm-6">
              <h3 className="footer-title">About Us</h3>

              <p>
                {webData?.aboutUsLong || "Loading..."}
              </p>

              <div className="social-section">
                <h5>Follow Us</h5>
                <div className="social-links">
                  {socialLinks.map((social, index) => (
                    social.url && (
                      <a
                        key={index}
                        href={social.url}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="social-link"
                        style={{ '--social-color': social.color }}
                        onMouseEnter={(e) => {
                          e.currentTarget.style.background = social.color;
                        }}
                        onMouseLeave={(e) => {
                          e.currentTarget.style.background = 'rgba(255,255,255,0.1)';
                        }}
                      >
                        {social.icon}
                      </a>
                    )
                  ))}
                </div>
              </div>
            </div>

            {/* Categories */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h3 className="footer-title">Categories</h3>
              <ul className="footer-links">
                {servCat && servCat.map((cat) => (
                  <li key={cat._id}>
                    <a href="#">
                      {cat.title}
                    </a>
                  </li>
                ))}
              </ul>
            </div>

            {/* Contact */}
            <div className="col-lg-3 col-md-6 col-sm-6">
              <h3 className="footer-title">Contacts</h3>

              <div className="contact-item">
                <MdLocationOn />
                <span>{webData?.address || "Loading..."}</span>
              </div>

              <div className="contact-item">
                <MdPhone />
                {webData?.phone && (
                  <a href={`tel:+91${webData.phone}`}>
                    +91 {webData.phone}
                  </a>
                )}
              </div>

              <div className="contact-item">
                <MdEmail />
                {webData?.email && (
                  <a href={`mailto:${webData.email}`}>
                    {webData.email}
                  </a>
                )}
              </div>
              {/* <div className="d-flex footer_qr">
                <div className="qrimageall">
                  <img src={paarbusiness} alt="paarbusiness" />
                </div>
                <div className="qrimageall">
                  <img src={paardigital} alt="paardigital" />
                </div>
              </div> */}
            </div>

          </div>

          <hr className="footer-divider" />

          <div className="row align-items-center footer-bottom">
            <div className="col-lg-6">
              <div className="selector-group">
                {/* Payment Icons */}
                <div className="payment-icons">
                  {paymentIcons.map((payment, index) => (
                    <span key={index} title={payment.name}>
                      {payment.icon}
                    </span>
                  ))}
                </div>
              </div>
            </div>


            <div className="col-lg-6">
              <ul className="footer-links-bottom">
                <li><Link to={"/contact"}>Contact Us</Link></li>
                {/* <li><Link to={"/terms"}>Terms and conditions</Link></li> */}
                <li><Link to={"/privacy"}>Privacy Policy</Link></li>
                <li>
                  <span className='text-white'>
                    © {year}. All rights reserved
                  </span>
                </li>
              </ul>
            </div>
          </div>

        </div>
      </footer>
    </>
  );
}

export default Contact;